import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { yonetim } from '../api';
import { ONAY_DURUMU, tarihSaat, tarih } from '../yardimcilar';
import DurumEtiketi from '../components/DurumEtiketi';
import Gorsel from '../components/Gorsel';
import OnayModal from '../components/OnayModal';

const BOS_FORM = {
  isletmeAdi: '', isletmeciAdSoyad: '', isyeriUnvani: '', telefon: '',
  eposta: '', adres: '', krediKartiKomisyonYuzde: 0, uyelikBitisTarihi: '',
};

export default function KuyumcuDetay({ onDegisim }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [detay, setDetay] = useState(null);
  const [form, setForm] = useState(BOS_FORM);
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');
  const [yukleniyor, setYukleniyor] = useState(true);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [kararAcik, setKararAcik] = useState(false);

  const yukle = useCallback(async () => {
    setYukleniyor(true);
    setHata('');
    try {
      const d = await yonetim.kuyumcuDetay(id);
      setDetay(d);
      setForm({
        isletmeAdi: d.isletmeAdi || '',
        isletmeciAdSoyad: d.isletmeciAdSoyad || '',
        isyeriUnvani: d.isyeriUnvani || '',
        telefon: d.telefon || '',
        eposta: d.eposta || '',
        adres: d.adres || '',
        krediKartiKomisyonYuzde: d.krediKartiKomisyonYuzde ?? 0,
        uyelikBitisTarihi: d.uyelikBitisTarihi || '',
      });
    } catch (e) {
      setHata(e.message);
    } finally {
      setYukleniyor(false);
    }
  }, [id]);

  useEffect(() => { yukle(); }, [yukle]);

  function alan(k, v) {
    setForm((f) => ({ ...f, [k]: v }));
  }

  async function kaydet(e) {
    e.preventDefault();
    setHata('');
    setBasari('');
    setKaydediliyor(true);
    try {
      await yonetim.kuyumcuDuzenle(id, {
        isletmeAdi: form.isletmeAdi.trim(),
        isletmeciAdSoyad: form.isletmeciAdSoyad.trim(),
        isyeriUnvani: form.isyeriUnvani.trim(),
        telefon: form.telefon.trim(),
        eposta: form.eposta.trim(),
        adres: form.adres.trim(),
        krediKartiKomisyonYuzde: Number(form.krediKartiKomisyonYuzde) || 0,
        uyelikBitisTarihi: form.uyelikBitisTarihi || null,
      });
      setBasari('Değişiklikler kaydedildi.');
      yukle();
    } catch (e2) {
      setHata(e2.message);
    } finally {
      setKaydediliyor(false);
    }
  }

  async function kararVer(onayla, redNedeni) {
    await yonetim.kuyumcuKarar(id, onayla, redNedeni);
    setKararAcik(false);
    setBasari(onayla ? 'Kuyumcu onaylandı.' : 'Kuyumcu reddedildi.');
    yukle();
    onDegisim && onDegisim();
  }

  if (yukleniyor) return <div className="yukleniyor">Yükleniyor…</div>;
  if (!detay) return <div className="mesaj hata">{hata || 'Kayıt bulunamadı.'}</div>;

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h1>{detay.isletmeAdi}</h1>
          <p>Kuyumcu #{detay.id} · Başvuru: {tarihSaat(detay.olusturmaUtc)}</p>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <DurumEtiketi durum={detay.onayDurumu} ad={detay.onayDurumuAdi} />
          <button className="btn btn-gray btn-sm" onClick={() => navigate('/kuyumcular')}>← Listeye dön</button>
        </div>
      </div>

      {hata && <div className="mesaj hata">{hata}</div>}
      {basari && <div className="mesaj basari">{basari}</div>}

      {detay.redNedeni && Number(detay.onayDurumu) === ONAY_DURUMU.REDDEDILDI && (
        <div className="mesaj hata"><strong>Red nedeni:</strong> {detay.redNedeni}</div>
      )}

      <div className="card">
        <div className="card-header">
          <h3>Başvuru bilgileri</h3>
          {Number(detay.onayDurumu) === ONAY_DURUMU.BEKLIYOR && (
            <button className="btn btn-primary" onClick={() => setKararAcik(true)}>Onayla / Reddet</button>
          )}
        </div>
        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
          <Gorsel url={detay.logoUrl} className="logo-kucuk" alt="logo" />
          <div className="detay-grid" style={{ flex: 1, minWidth: 280 }}>
            <div className="etiket">İl / İlçe</div>
            <div className="deger">{detay.ilAdi}{detay.ilceAdi ? ` / ${detay.ilceAdi}` : ''}</div>
            <div className="etiket">Vergi no</div>
            <div className="deger">{detay.vergiNo || '-'}</div>
            <div className="etiket">Adres</div>
            <div className="deger">{detay.adres}</div>
            <div className="etiket">Üyelik bitişi</div>
            <div className="deger">{tarih(detay.uyelikBitisTarihi)}</div>
            <div className="etiket">Bugün alım yapıyor</div>
            <div className="deger">{detay.bugunAlimYapiyorum ? 'Evet' : 'Hayır'}</div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header"><h3>Bilgileri düzenle</h3></div>
        <form onSubmit={kaydet}>
          <div className="form-row">
            <div className="form-group">
              <label>İşletme adı</label>
              <input value={form.isletmeAdi} onChange={(e) => alan('isletmeAdi', e.target.value)} required maxLength={150} />
            </div>
            <div className="form-group">
              <label>İşletmeci ad soyad</label>
              <input value={form.isletmeciAdSoyad} onChange={(e) => alan('isletmeciAdSoyad', e.target.value)} required maxLength={120} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>İşyeri unvanı</label>
              <input value={form.isyeriUnvani} onChange={(e) => alan('isyeriUnvani', e.target.value)} required maxLength={150} />
            </div>
            <div className="form-group">
              <label>Telefon</label>
              <input value={form.telefon} onChange={(e) => alan('telefon', e.target.value)} required maxLength={20} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>E-posta</label>
              <input type="email" value={form.eposta} onChange={(e) => alan('eposta', e.target.value)} required maxLength={150} />
            </div>
            <div className="form-group">
              <label>Kredi kartı komisyonu (%)</label>
              <input type="number" step="0.01" min="0" max="100" value={form.krediKartiKomisyonYuzde}
                onChange={(e) => alan('krediKartiKomisyonYuzde', e.target.value)} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Adres</label>
              <input value={form.adres} onChange={(e) => alan('adres', e.target.value)} required maxLength={400} />
            </div>
            <div className="form-group">
              <label>Üyelik bitiş tarihi</label>
              <input type="date" value={form.uyelikBitisTarihi || ''} onChange={(e) => alan('uyelikBitisTarihi', e.target.value)} />
            </div>
          </div>
          <button type="submit" className="btn btn-primary" disabled={kaydediliyor}>
            {kaydediliyor ? 'Kaydediliyor…' : 'Değişiklikleri kaydet'}
          </button>
        </form>
      </div>

      {kararAcik && (
        <OnayModal
          baslik={`Kuyumcu kararı — ${detay.isletmeAdi}`}
          aciklama="Kaydetmediğiniz düzenlemeler bu karara dahil olmaz. Reddederseniz gerekçe girmelisiniz."
          onKarar={kararVer}
          onKapat={() => setKararAcik(false)}
        />
      )}
    </div>
  );
}
